
// import { apis, serverCall } from "../../utils/api/constant";
import { apis, serverCall } from "../../utils/api/constant";
import { getCategoryData, getSubCategoryData, setSubCategoryData } from "../../utils/utility";
import { fetchAllDropDownDataSuccess, fetchChargingNameCategorySuccess, fetchChargingParameterCategorySuccess, fetchChargingTypeCategorySuccess, fetchChargingUnitCategorySuccess, fetchDashboardDataSuccess, fetchDeleteSearchData, fetchEditSearchData, fetchRateTypeCategorySuccess, fetchSearchDataSuccess, fetchStatusDataSuccess, fetchSubCategorySuccess, fetchSupplierCategorySuccess, fetchUnitCategorySuccess,fetchPaymentAndBalanceGraph,fetchUsagesGraph,fetchDisconnectionAndReconnectionGraph,fetchNotificationGraph } from "./action";
import { logOut } from "../../Logout";
// Thunk action creator
export const fetchDashboardSuccess = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 3, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": "", "param3": 0, "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      console.log('122222333556677788899987655432')
      console.log(response)
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchDashboardDataSuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};

export const fetchSubCategory = (userData, subCatID) => {
  return async (dispatch, getState) => {
    try {
      setSubCategoryData(subCatID);
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 4, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": getCategoryData(), "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchSubCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};
export const fetchSupplierCategory = (userData, suppCatID) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 5, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": getSubCategoryData(), "param3": "", "param4": suppCatID, "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchSupplierCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};

export const fetchUnitCategory = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 7, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": userData?.pDATASET[0]?.CIRCLE_ID, "param3": getSubCategoryData(), "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchUnitCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};


export const fetchChargingNameCategory = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 9, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": userData?.pDATASET[0]?.CIRCLE_ID, "param3": getSubCategoryData(), "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchChargingNameCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};


export const fetchChargingTypeCategory = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 10, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": userData?.pDATASET[0]?.CIRCLE_ID, "param3": getSubCategoryData(), "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchChargingTypeCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};



export const fetchChargingParameterCategory = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 11, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": userData?.pDATASET[0]?.CIRCLE_ID, "param3": getSubCategoryData(), "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchChargingParameterCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};


export const fetchUnitCategoryOtherCharges = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 7, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": userData?.pDATASET[0]?.CIRCLE_ID, "param3": getSubCategoryData(), "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchChargingUnitCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};
export const fetchRateTypeCategory = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 8, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": userData?.pDATASET[0]?.CIRCLE_ID, "param3": getSubCategoryData(), "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchRateTypeCategorySuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};

export const fetchStatus = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 18, "param1": userData?.pDATASET[0]?.STATE_ID, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchStatusDataSuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};

export const fetchSearchData = (userData) => {
  return async (dispatch) => {
    try {
      dispatch(fetchSearchDataSuccess(null));
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.userData?.pDATASET[0]?.USERNAME, "apiID": 16, "param1":userData?.userData?.pDATASET[0]?.CIRCLE_ID, "param2":(userData?.formdata?.TariffServiceCategory)? userData?.formdata?.TariffServiceCategory:'' , "param3": (userData?.formdata?.TariffSubCategoryCategory)? userData?.formdata?.TariffSubCategoryCategory:'', "param4":(userData?.formdata?.TariffSupplierTypeCategory)?userData?.formdata?.TariffSupplierTypeCategory:"", "param5":(userData?.formdata?.Status)?  userData?.formdata?.Status:'', "param6":(userData?.formdata?.TariffName)?  userData?.formdata?.TariffName:''}, { "sid": userData?.userData?.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchSearchDataSuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};

export const fetchEditSearch = (userData,navigate) => {
  return async (dispatch) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.userData?.pDATASET[0]?.USERNAME, "apiID": 17, "param1": userData?.id, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData?.userData?.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchEditSearchData(response.data));
        navigate("/NewTariff");
      } else {
      }
    } catch (error) {
    }
  };
};


export const fetchDeleteSearch = (userData) => {
  return async (dispatch) => {
    try {
      let response = await serverCall(apis.UPLOAD_NEWTARIFF_DATA, "POST", {
        "userName": userData?.userData?.pDATASET[0]?.USERNAME, "apiID": 2, "data": {
          "masterValueData": {
            "TariffId": userData?.id,
            "UserName": userData?.userData?.pDATASET[0]?.USERNAME
          }
        }
      }, { "sid": userData?.userData?.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchDeleteSearchData(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};



export const fetchAllDropDownData = (userData) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 18, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data)
        logOut(response.data); // Run logout function on error
      }
      if (response.success) {
        dispatch(fetchAllDropDownDataSuccess(response.data));
      } else {
      }
    } catch (error) {
    }
  };
};


export const paymentAndBalanceGraph = (userData) => {
   return async (dispatch, getState) => {
        // dispatch(fetchDataRequest());
        try {
          // const response = await axios.get('https://api.example.com/data');
          let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 19, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });

          // let response = await serverCall(apis.USER_LOGIN, "POST", {"apiID": 19,"userName":userName,"password":password,CIRCLE_ID});
          if (!response?.data?.ERROR_STATUS) {
            console.log(response.data)
            logOut(response.data); // Run logout function on error
          }
         
          if(response.success){
              console.log(response)
              dispatch(fetchPaymentAndBalanceGraph(response.data))
       
          }
        } catch (error) {
          console.log("paymentAndBalnaceGraph Api Error")
        }
      };
}


export const usagesGraph = (userData) => {
  return async (dispatch, getState) => {
       // dispatch(fetchDataRequest());
       try {
         // const response = await axios.get('https://api.example.com/data');
         let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 20, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });

         // let response = await serverCall(apis.USER_LOGIN, "POST", {"apiID": 19,"userName":userName,"password":password,CIRCLE_ID});
         if (!response?.data?.ERROR_STATUS) {
           console.log(response.data)
           logOut(response.data); // Run logout function on error
         }
        
         if(response.success){
             console.log(response)
             dispatch(fetchUsagesGraph(response.data))
      
         }
       } catch (error) {
         console.log("paymentAndBalnaceGraph Api Error")
       }
     };
}


export const disconnectionAndReconnection = (userData) => {
  return async (dispatch, getState) => {
       // dispatch(fetchDataRequest());
       try {
         // const response = await axios.get('https://api.example.com/data');
         let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 21, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });

         // let response = await serverCall(apis.USER_LOGIN, "POST", {"apiID": 19,"userName":userName,"password":password,CIRCLE_ID});
         if (!response?.data?.ERROR_STATUS) {
           console.log(response.data)
           logOut(response.data); // Run logout function on error
         }
        
         if(response.success){
           
             dispatch(fetchDisconnectionAndReconnectionGraph(response.data))
      
         }
       } catch (error) {
         console.log("paymentAndBalnaceGraph Api Error")
       }
     };
}


export const notificationGraph = (userData) => {
  return async (dispatch, getState) => {
       // dispatch(fetchDataRequest());
       try {
         // const response = await axios.get('https://api.example.com/data');
         let response = await serverCall(apis.FETCH_DATA, "POST", { "userName": userData?.pDATASET[0]?.USERNAME, "apiID": 22, "param1": userData?.pDATASET[0]?.CIRCLE_ID, "param2": "", "param3": "", "param4": "", "param5": "", "param6": "" }, { "sid": userData.token });

         // let response = await serverCall(apis.USER_LOGIN, "POST", {"apiID": 19,"userName":userName,"password":password,CIRCLE_ID});
         if (!response?.data?.ERROR_STATUS) {
           console.log(response.data)
           logOut(response.data); // Run logout function on error
         }
         if(response.success){
        
             dispatch(fetchNotificationGraph(response.data))
         }
       } catch (error) {
         console.log("paymentAndBalnaceGraph Api Error")
       }
     };
}